import { CacheKey } from '@libs/vercel-edge-rt';
import { useCacheKey } from '@libs/common-next';
import css from './key.module.scss';

interface Props {
    value: string;
    onChange: (value: string) => void;
}
export function Key({ value, onChange }: Props) {
    const ck = useCacheKey();
    const valid = CacheKey.isValid(value);
    const bytes = new TextEncoder().encode(value).length;
    const size = bytes < 1024 ? `${bytes} B` : `${(bytes / 1024).toFixed(2)} Kb`;

    return (
        <article className={css.wrapper}>
            <p className={css.header}>
                Cache key
                <button className={css.reset} onClick={() => onChange(ck.key)}>
                    <span className={css.icon}>↻</span>
                    Reset
                </button>
            </p>
            <div className={css.status}>
                <span className={css.icon}>{valid ? '✓ Verified' : '✕ Invalid format'}</span>
                <div>
                    <span className={css.size}>{size}</span>
                    <span className={css.total}> / 14 Kb</span>
                </div>
            </div>

            <div className={css.key}>
                <textarea
                    value={value}
                    name="cache-key"
                    className={css.input}
                    onChange={e => onChange(e.target.value)}
                    autoComplete="off"
                />
            </div>
        </article>
    );
}
